import { render, staticRenderFns } from "./input-copy.vue?vue&type=template&id=5ed45196&"
import script from "./input-copy.vue?vue&type=script&lang=js&"
export * from "./input-copy.vue?vue&type=script&lang=js&"
import style0 from "./input-copy.vue?vue&type=style&index=0&id=5ed45196&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports